import { Fault } from '@dreryk/command-query-ws-api';
import { MissingHealthcareProviderActiveP1CertificatesFault } from '@dreryk/egabinet-p1-frontend-api';
import { PrescriptionPackageDeferredResultFault } from '@dreryk/egabinet-prescription-frontend-api';
import { NoValidCertificateFoundFault } from '@dreryk/egabinet-truststore-published-language-api';

import { TranslatableText } from '@dreryk/react-common';
import { Anchor, MessageType } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../translations';

import { PrescriptionStatus } from './common/PrescriptionStatus';

type FaultTypes =
   | NoValidCertificateFoundFault
   | MissingHealthcareProviderActiveP1CertificatesFault
   | PrescriptionPackageDeferredResultFault;

const mapFaultToTranslationKey = (fault: FaultTypes): TranslatableText | null => {
   switch (fault.class) {
      case 'egabinet-truststore:NoValidCertificateFoundFault':
         return draftPrescriptionsTranslationKeys.missingDoctorActiveP1CertificateFault;
      case 'egabinet-p1-frontend-api:MissingHealthcareProviderActiveP1CertificatesFault':
         return draftPrescriptionsTranslationKeys.missingHealthCareInstitutionActiveP1CertificatesFault;
      case 'egabinet-prescription-frontend-api:PrescriptionPackageDeferredResultFault':
         return draftPrescriptionsTranslationKeys.prescriptionPackageDeferredResultFault;
      default:
         return null;
   }
};

type SendPrescriptionErrorStatusProps = {
   readonly fault: Fault;
};

export const SendPrescriptionErrorStatus = (props: SendPrescriptionErrorStatusProps): JSX.Element | null => {
   const translationKey = mapFaultToTranslationKey(props.fault as FaultTypes);
   if (!translationKey) {
      return null;
   }

   return (
      <Anchor testId={'sendPrescriptionError'} shouldPerformScroll>
         <PrescriptionStatus testId={'sendPrescriptionError'} type={MessageType.NEGATIVE} label={translationKey} />
      </Anchor>
   );
};
